import React from 'react';
import { cn } from '@/lib/utils';

interface DashboardSkeletonProps {
  className?: string;
}

// Casca puramente visual do dashboard (sidebar + header + cards) em estado "skeleton".
// Serve de pré-render borrado atrás do modal de seleção de conta. Não busca dados.
const DashboardSkeleton: React.FC<DashboardSkeletonProps> = ({ className }) => {
  return (
    <div className={cn('min-h-screen flex bg-muted/30', className)} aria-hidden="true">
      {/* Sidebar */}
      <aside className="hidden md:flex w-64 flex-col gap-4 border-r bg-background p-4">
        <div className="h-10 w-32 rounded-md bg-muted animate-pulse" />
        <div className="mt-4 space-y-2">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="h-9 w-full rounded-md bg-muted animate-pulse" />
          ))}
        </div>
      </aside>

      {/* Conteúdo */}
      <main className="flex-1 flex flex-col">
        {/* Header */}
        <div className="h-16 border-b bg-background flex items-center justify-between px-6">
          <div className="h-6 w-48 rounded-md bg-muted animate-pulse" />
          <div className="h-9 w-40 rounded-md bg-muted animate-pulse" />
        </div>

        {/* Cards */}
        <div className="p-6 space-y-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="h-28 rounded-xl bg-background border p-4">
                <div className="h-4 w-24 rounded bg-muted animate-pulse" />
                <div className="mt-4 h-8 w-16 rounded bg-muted animate-pulse" />
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {Array.from({ length: 2 }).map((_, i) => (
              <div key={i} className="h-64 rounded-xl bg-background border p-4">
                <div className="h-5 w-40 rounded bg-muted animate-pulse" />
                <div className="mt-6 h-40 w-full rounded bg-muted animate-pulse" />
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default DashboardSkeleton;
